import React from 'react';

import {
    matchPath,
} from 'react-router';

import { routes as AboutUsRoutes } from 'wanderu-app-about-us';
import { routes as BookingRoutes } from 'wanderu-app-booking';
import { routes as ExploreRoutes } from 'wanderu-app-explorer';
import { routes as GetTheAppRoutes } from 'wanderu-app-gettheapp';
import { routes as HomePageRoutes } from 'wanderu-app-homepage';
import { routes as ProductReviewRoutes } from 'wanderu-app-product-review';
import { routes as ResearchRoutes } from 'wanderu-app-research';
import { routes as SearchRoutes } from 'wanderu-app-search';
import {
    routes as SeoRoutes,
    deletedRoutes as deletedSEOPaths,
} from 'wanderu-app-seo';
import { routes as ShuttleRoutes } from 'wanderu-app-shuttle-pages';
import { routes as StationRoutes } from 'wanderu-app-station-pages';
import { routes as TermsAndConditionsRoutes } from 'wanderu-app-terms-and-conditions';
import { routes as TripSummaryRoutes } from 'wanderu-app-tripsummary';
import { routes as UserAccountsRoutes } from 'wanderu-app-useraccounts';
// eslint-disable-next-line import/no-named-as-default
import NotFound from 'wanderu-component-not-found';
import {
    i18nRedirect,
} from 'wanderu-hocs';

import HandleRedirects from './HandleRedirects';
import deletedRoutes from './deletedRoutes';
import localeConfig from '../config/baseApp.locales';
import App from '../containers/App';
import FooterPage from '../containers/FooterPage/FooterPage';
import HeaderPage from '../containers/HeaderPage/HeaderPage';

const allSubRoutes = [
    ...AboutUsRoutes,
    ...BookingRoutes,
    ...HomePageRoutes,
    ...ExploreRoutes,
    ...SearchRoutes,
    ...TripSummaryRoutes,
    ...SeoRoutes,
    ...UserAccountsRoutes,
    ...GetTheAppRoutes,
    ...ProductReviewRoutes,
    ...TermsAndConditionsRoutes,
    ...StationRoutes,
    ...ShuttleRoutes,
    ...ResearchRoutes,
];

const pathsTo404 = [
    ...deletedSEOPaths,
];

const routesTo404 = pathsTo404.map((path) => ({
    component: NotFound,
    key: path,
    path: path,
}));

const I18nApp = i18nRedirect(App, {
    defaultLocale: localeConfig.defaultLocale,
    homepagePath: '/',
    knownBasePaths: getRoutePaths(allSubRoutes),
    localeRedirectBlacklist: [
        ...getRoutePaths(routesTo404),
    ],
    localeToCurrencyMap: localeConfig.currencyMap,
});

let routes = [
    {
        component: HandleRedirects,
        key: 'handleRedirects',
        routes: [
            {
                component: HeaderPage,
                exact: true,
                key: '/:locale/partner/header/',
                path: '/:locale/partner/header/',
                strict: true,
            },
            {
                component: FooterPage,
                exact: true,
                key: '/:locale/partner/footer/',
                path: '/:locale/partner/footer/',
                strict: true,
            },
            {
                component: HeaderPage,
                exact: true,
                key: '/partner/header/',
                path: '/partner/header/',
                strict: true,
            },
            {
                component: FooterPage,
                exact: true,
                key: '/partner/footer/',
                path: '/partner/footer/',
                strict: true,
            },
            {
                component: I18nApp,
                key: '/',
                path: '/:locale?',
                routes: [
                    ...HomePageRoutes,
                    ...deletedRoutes,
                    ...routesTo404,
                    ...prependLocalePathToRoutes(allSubRoutes),
                    {
                        component: (props) => {
                            const { staticContext = {} } = props;
                            if (staticContext.action) {
                                return null;
                            }

                            return <NotFound {...props} />;
                        },
                        key: 'notFound',
                        path: '/:locale/*',
                    },
                ],
            },
        ],
    },
];

if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line global-require, @typescript-eslint/no-require-imports
    const scratchRoutes = require('../containers/ScratchPad/routes').default;
    routes = [
        ...routes.slice(0, routes.length - 1),
        ...scratchRoutes,
        routes[routes.length - 1],
    ];
}

function getRoutePaths(routesArr) {
    return routesArr.map((route) => (url) => !!matchPath(url, route));
}

function prependLocalePathToRoutes(routesArr) {
    if (!routesArr) {
        return undefined;
    }

    return routesArr.map((routeObj) => {
        return {
            ...routeObj,
            key: `/:locale${routeObj.path}`,
            path: `/:locale${routeObj.path}`,
            routes: prependLocalePathToRoutes(routeObj.routes),
        };
    });
}

function augmentRoutesWithParentKeys(routesArr, parentKey) {
    return routesArr.map((route) => {
        const {
            key,
        } = route;

        if (!key) {
            throw new Error(`All routes must have a key: check ${route.path}`);
        }

        if (route?.routes) {
            augmentRoutesWithParentKeys(route?.routes, key);
        }

        if (!parentKey) {
            return route;
        }

        return {
            ...route,
            parentKey,
        };
    });
}

export default augmentRoutesWithParentKeys(routes);
